import { useTranslation } from 'react-i18next';
import type { Project } from '../data/projects';
import { userCountAffixes, userReach } from '../data/reach';
import { formatInteger } from '../i18n/formatNumber';
import { useLanguage } from '../i18n/useLanguage';
import { usePlatformLabel } from './usePlatformLabel';

export function useProjectKeyFact(): (project: Project) => string {
    const { t } = useTranslation();
    const { language } = useLanguage();
    const platformLabel = usePlatformLabel();

    return (project: Project) => {
        const users = userReach(project);
        if (!users) return platformLabel(project.platforms);
        const { prefix, suffix } = userCountAffixes(users);
        return t('project.reach', { users: `${prefix}${formatInteger(users.count, language)}${suffix}` });
    };
}
